/**
 * @created : 2021/3/26
 * @author  : 王冲
 * @desc    : 邀请
 */

import { request } from "@weapp/utils";
import { mainHost } from "../../utils";
import { publicUrlapi } from "../../constants";
const ETEAMSID = window.ETEAMSID;
const host = mainHost();
const passport = window.weappTenantEnv?.passportUrl || window.TEAMS.passportUrl;

// app扫码登录
export const appLogin = (etoken: any, jsessionid: any) => {
  const formData = new FormData();
  formData.append("etoken", etoken);
  formData.append("jsessionid", jsessionid);
  return request({
    url: `${passport}${publicUrlapi}/papi/passport/qrlogin/applogin?service=${encodeURIComponent(window.weappTenantEnv?.weappUrl || "")}`,
    method: "post",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data: formData,
  });
};

